/* No FareHarbor loader: use the existing theme's autolightframe integration. */
(() => {
  if (window.vgPremiumInitialized) return;
  window.vgPremiumInitialized = true;
  const roots = new Map();
  const analytics = (event, detail) => {
    // The consent manager / GTM must gate outbound tags. Never emit a purchase event.
    if (window.Shopify?.designMode) return;
    if (
      window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true
    )
      return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, currency: "AUD", ...detail });
  };
  const init = (scope = document) => {
    const elements = [...scope.querySelectorAll("[data-vg-experiences]")];
    if (scope.matches?.("[data-vg-experiences]")) elements.unshift(scope);
    elements.forEach((root) => {
      if (roots.has(root)) return;
      const controller = new AbortController();
      roots.set(root, controller);
      const signal = controller.signal;
      const options = root.querySelectorAll("[data-vg-option]");
      // Hide the interactive suggestion controls if JS is unavailable; cards remain usable.
      const finder = root.querySelector("[data-vg-finder]");
      if (finder) finder.hidden = false;
      options.forEach((button) =>
        button.addEventListener(
          "click",
          () => {
            const { value, title, description, checkoutUrl } = button.dataset;
            options.forEach((option) =>
              option.setAttribute("aria-pressed", String(option === button)),
            );
            root.querySelector("[data-vg-value]").textContent = `$${value} AUD`;
            root.querySelector("[data-vg-title]").textContent = title;
            root.querySelector("[data-vg-description]").textContent =
              description;
            root.querySelectorAll("[data-vg-selected]").forEach((link) => {
              if (checkoutUrl) link.href = checkoutUrl;
              link.dataset.value = value;
              link.dataset.experience = title;
              link.querySelector("[data-vg-button-value]").textContent =
                `$${value}`;
            });
            const stickyTitle = root.querySelector("[data-vg-sticky-title]");
            if (stickyTitle) stickyTitle.textContent = title;
            analytics("gift_voucher_select", {
              voucher_value: Number(value),
              experience: title,
            });
          },
          { signal },
        ),
      );
      root.querySelectorAll("[data-vg-buy]").forEach((link) =>
        link.addEventListener(
          "click",
          () => {
            analytics("gift_voucher_click", {
              voucher_value: Number(link.dataset.value),
              experience: link.dataset.experience,
              cta_location: link.dataset.location,
              amount_preselected: false,
            });
            // Retain the native URL and allow the theme's FareHarbor handler to enhance it.
          },
          { signal },
        ),
      );
    });
  };
  init();
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) => {
    roots.forEach((controller, root) => {
      if (event.target === root || event.target.contains(root)) {
        controller.abort();
        roots.delete(root);
      }
    });
  });
})();
